import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import EQuotePreviewPackageOutline from '../outline/EQuotePreviewPackageOutline'
import EQuotePackageHeroSlider from '../heroSlider/EQuotePackageHeroSlider'
import EQuotePackagePreviewHighlights from '../cruiseHighlights/EQuotePreviewPackageCruiseHighlights'
import EQuotePackageItinerary from '../itinerary/EQuotePackageItinerary'
import EQuotePreviewPackageShipDetails from '../ship/EQuotePreviewPackageShipDetails'
import EQuotePackageStateRooms from '../staterooms/EQuotePackageStateRooms'
import EQuoteAgentDetailsFooter from '../agent/EQuoteAgentDetailsFooter'
import EQuotePreviewPackageNavigation from './EQuotePreviewPackageNavigation'
import EQuotePackageRelatedSailings from '../relatedSailings/EQuotePackageRelatedSailings'
import EQuotePackageDetailsLandPrograms from '../landPackage/EQuotePackageLandPrograms'
import { getActivePackageData } from '../../reducers/activePackage'
import { getBrandClassName, getItinerary } from '../../reducers/packageDetails'
import { getSingleBrandDetails } from '../../reducers/brands'
import tourIconDark from '../../assets/icons/360-tour-dark.svg'
import { getTermsByCurrency } from '../../reducers/labelsData'

class EQuotePreviewPackageContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      virtualTourModalIsOpen: false,
      virtualTourTitle: null,
      virtualTourLink: null
    }
  }

  openVirtualTourModal = ({ link, title }) => {
    this.setState({
      virtualTourModalIsOpen: true,
      virtualTourTitle: title,
      virtualTourLink: link
    })
  }

  closeVirtualTourModal = () => {
    this.setState({
      virtualTourModalIsOpen: false,
      virtualTourTitle: null,
      virtualTourLink: null
    })
  }

  render() {
    const {
      activePackage,
      itinerary,
      brandDetails,
      brandClassName,
      searchParameters,
      terms
    } = this.props

    if (!activePackage) return null

    return (
      <div>
        <EQuotePreviewPackageOutline
          packageDetails={activePackage}
          itinerary={itinerary}
          currentBrand={brandDetails}
        />
        <EQuotePackageHeroSlider />
        <EQuotePreviewPackageNavigation />
        <EQuotePackagePreviewHighlights
          brandClassName={brandClassName}
          brandDetails={brandDetails}
        />
        <EQuotePackageDetailsLandPrograms
          landPrograms={activePackage.landPrograms}
        />
        <EQuotePackageItinerary
          activePackage={activePackage}
          itinerary={itinerary}
          brandClassName={brandClassName}
        />
        <EQuotePreviewPackageShipDetails
          openVirtualTourModal={this.openVirtualTourModal}
        />
        <EQuotePackageStateRooms
          activePackage={activePackage}
          brandClassName={brandClassName}
          searchParameters={searchParameters}
          openVirtualTour={this.openVirtualTourModal}
          terms={terms}
        />
        {/* {activePackage?.groupId === null && <EQuotePackageRelatedSailings />} */}
        <EQuotePackageRelatedSailings />
        <EQuoteAgentDetailsFooter brandClassName={brandClassName} />
        {this.state.virtualTourModalIsOpen && (
          <Modal
            className={{
              base: 'u-modal virtual-tour-modal',
              afterOpen: 'u-modal--visible',
              beforeClose: 'u-modal--close',
              ariaHideApp: false
            }}
            overlayClassName={{
              base: 'u-fade',
              afterOpen: 'u-fade--visible u-add-padding',
              beforeClose: 'u-fade--visible'
            }}
            contentLabel="eQuote Virtual Tour"
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
            htmlOpenClassName="ReactModal__Html--open"
            isOpen={this.state.virtualTourModalIsOpen}
            onRequestClose={this.closeVirtualTourModal}
          >
            <div className="virtual-tour-modal-content">
              <div className="virtual-tour-modal-header">
                <div className="virtual-tour-modal-title-container">
                  <img
                    src={tourIconDark}
                    alt={this.state.virtualTourTitle || 'Virtual Tour'}
                  />
                  <h1 className="virtual-tour-modal-title">
                    {this.state.virtualTourTitle}
                  </h1>
                </div>
                <button className="btn " onClick={this.closeVirtualTourModal}>
                  Close X
                </button>
              </div>
              <div className="virtual-tour-frame-container">
                <iframe
                  title={this.state.virtualTourTile}
                  src={this.state.virtualTourLink}
                  frameBorder="0"
                  allow="vr"
                  allowFullScreen="allowfullscreen"
                />
              </div>
            </div>
          </Modal>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  activePackage: getActivePackageData(state),
  itinerary: getItinerary(state),
  brandClassName: getBrandClassName(state),
  brandDetails: getSingleBrandDetails(state),
  searchParameters: state.activeSearchParameters,
  terms: getTermsByCurrency(state)
})

export default connect(mapStateToProps)(EQuotePreviewPackageContent)
